import React, { useContext, useState, useEffect } from 'react';
import CbmContext from '../../Context/Cbm/cbmContext';
import AdminContext from '../../Context/Admin/adminContext';
import './ErrorBanner.css';

const ErrorBanner = () => {
  const cbm = useContext(CbmContext);
  const admin = useContext(AdminContext);
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [reference, setReference] = useState('');

  useEffect(() => {
    // Prefer context-level userFriendlyMessage if available
    const msg =
      cbm.userFriendlyMessage ||
      admin?.userFriendlyMessage ||
      cbm.errorMessage ||
      admin?.errorMessage ||
      '';
    const ref = cbm.errorReference || admin?.errorReference || '';

    if (msg) {
      setMessage(msg);
      setReference(ref);
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [
    cbm.userFriendlyMessage,
    cbm.errorMessage,
    cbm.errorReference,
    admin?.userFriendlyMessage,
    admin?.errorMessage,
    admin?.errorReference,
  ]);

  const onClose = () => {
    setVisible(false);
    if (cbm.clearErrorsImmediate) cbm.clearErrorsImmediate();
    else if (cbm.clearErrors) cbm.clearErrors();
    if (admin && admin.clearAdminErrors) admin.clearAdminErrors();
  };

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(
        message + (reference ? `\nReference: ${reference}` : '')
      );
      // quick user feedback
      setMessage((prev) => `${prev} — Copied to clipboard`);
      setTimeout(() => {
        // remove copied suffix
        setMessage((prev) => prev.replace(' — Copied to clipboard', ''));
      }, 1500);
    } catch (err) {
      console.error('Copy failed', err);
    }
  };

  if (!visible) return null;

  return (
    <div className="error-banner" role="alert" aria-live="polite">
      <div className="error-banner-inner">
        <div className="error-banner-message">
          <strong>Error:</strong>&nbsp;{message}
          {reference ? (
            <span className="error-banner-ref">
              &nbsp;|&nbsp;Ref: {reference}
            </span>
          ) : null}
        </div>
        <div className="error-banner-actions">
          <button className="error-banner-copy" onClick={onCopy}>
            Copy
          </button>
          <button className="error-banner-close" onClick={onClose}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorBanner;
